import { displayName } from "@/data/nicknames";

const GAMES = [
  { name: "Buy-In", cost: "$35", detail: "Per player, every Saturday" },
  { name: "Dots Game", cost: "$30", detail: "Pot split by value per dot" },
  { name: "Par In", cost: "$5", detail: "17 or better on holes 15–18" },
  { name: "Rabbit & Squirrel", cost: "$5 / $2", detail: "Rabbit: $5 from every player · Squirrel: $2" },
];

export const RosterState = ({ names = [] }) => (
  <div className="mt-6 space-y-8" data-testid="roster-state">
    <p className="rounded-md border border-cypress-gold/40 bg-cypress-gold/10 px-4 py-3 font-mono text-sm text-cypress-gold" data-testid="season-start-note">
      The season tees off this Saturday. Numbers go up as soon as the first round is in — from there the board sorts itself, best to worst.
    </p>

    <div>
      <h3 className="text-[10px] font-bold uppercase tracking-[0.2em] text-cypress-cream/50">The Games</h3>
      <div className="mt-3 grid grid-cols-2 gap-3 lg:grid-cols-4" data-testid="games-cost-tiles">
        {GAMES.map((g) => (
          <div
            key={g.name}
            className="rounded-lg border border-cypress-gold/20 bg-cypress-green/40 px-4 py-3"
            data-testid={`game-tile-${g.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-cypress-cream/50">{g.name}</p>
            <p className="mt-1 font-mono text-xl font-bold text-cypress-gold sm:text-2xl">{g.cost}</p>
            <p className="mt-1 text-xs text-cypress-cream/50">{g.detail}</p>
          </div>
        ))}
      </div>
    </div>

    {names.length > 0 && (
      <div>
        <h3 className="text-[10px] font-bold uppercase tracking-[0.2em] text-cypress-cream/50">The Roster</h3>
      <ul className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3" data-testid="roster-list">
        {names.map((name, i) => (
          <li
            key={name}
            data-testid={`roster-player-${i + 1}`}
            className="flex items-center gap-3 rounded-lg border border-cypress-gold/15 bg-cypress-green/40 px-4 py-3"
          >
            <span className="font-mono text-sm font-bold text-cypress-gold">{i + 1}</span>
            <span className="font-semibold tracking-tight">{displayName(name)}</span>
          </li>
        ))}
      </ul>
      </div>
    )}
  </div>
);
